export interface MovieItem {
  id: string;
  title: string;
  year: number;
  type: "movie" | "tv";
  genre: string[];
  region: string;
  rating: number;
  cover: string;
  summary: string;
  review: string;
  director: string;
  actorIds: string[];
  duration: string;
  clicks: number;
}

export const movies: MovieItem[] = [
  {
    id: "m001",
    title: "暗夜潮汐",
    year: 2024,
    type: "movie",
    genre: ["悬疑", "犯罪"],
    region: "中国大陆",
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20movie%20poster%20of%20a%20mysterious%20detective%20standing%20on%20a%20rainy%20pier%20at%20night%2C%20deep%20blue%20and%20teal%20tones%2C%20dramatic%20rim%20light%2C%20crime%20thriller%20aesthetic%2C%20high%20contrast%20film%20grain&width=600&height=840&seq=movie-m001-01&orientation=portrait",
    summary: "一名刑警在调查连环失踪案时，逐渐发现案件背后牵扯着一座滨海城市尘封多年的秘密。",
    review: "影片以冷峻的影像语言构建出压抑而紧张的叙事氛围，导演对节奏的掌控极具功力，悬疑反转层层递进，是近年来国产犯罪片中少见的佳作。演员的表演克制而有张力，尤其是主角在审讯戏中的情绪爆发令人印象深刻。",
    director: "林远舟",
    actorIds: ["a001", "a002"],
    duration: "126分钟",
    clicks: 98230,
  },
  {
    id: "m002",
    title: "星河彼岸",
    year: 2023,
    type: "movie",
    genre: ["科幻", "冒险"],
    region: "美国",
    rating: 9.1,
    cover: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20a%20lone%20astronaut%20facing%20a%20glowing%20distant%20galaxy%2C%20deep%20navy%20blue%20space%20background%2C%20warm%20orange%20nebula%20light%2C%20cinematic%20wide%20composition%2C%20hopeful%20atmosphere&width=600&height=840&seq=movie-m002-01&orientation=portrait",
    summary: "人类最后一批探索者穿越虫洞，寻找适宜居住的新家园，却意外发现了文明的真相。",
    review: "视觉效果震撼大气，世界观设定宏大且自洽，情感线索处理得克制而动人。影片在探讨人类存续议题的同时，没有忽略角色的个人成长，是一部兼具观赏性与思考深度的太空史诗。",
    director: "Eleanor Hayes",
    actorIds: ["a003", "a004"],
    duration: "148分钟",
    clicks: 156420,
  },
  {
    id: "m003",
    title: "烟火人间",
    year: 2022,
    type: "movie",
    genre: ["剧情", "家庭"],
    region: "中国大陆",
    rating: 8.3,
    cover: "https://readdy.ai/api/search-image?query=Warm%20realistic%20family%20drama%20movie%20poster%2C%20an%20elderly%20woman%20and%20a%20young%20girl%20sitting%20by%20a%20window%20at%20golden%20hour%2C%20soft%20warm%20orange%20light%2C%20cozy%20domestic%20scene%2C%20emotional%20tone&width=600&height=840&seq=movie-m003-01&orientation=portrait",
    summary: "讲述一个普通家庭三代人在时代变迁中相互扶持、彼此理解的温情故事。",
    review: "没有激烈的戏剧冲突，却凭借真实细腻的生活质感打动人心。导演擅长捕捉日常中的情感瞬间，演员群像表演自然流畅，是一部值得静下心来观看的温暖之作。",
    director: "周海棠",
    actorIds: ["a002", "a005"],
    duration: "118分钟",
    clicks: 72310,
  },
  {
    id: "m004",
    title: "无声证人",
    year: 2024,
    type: "movie",
    genre: ["悬疑", "法律"],
    region: "韩国",
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Intense%20courtroom%20thriller%20movie%20poster%2C%20a%20lawyer%20standing%20in%20a%20dim%20courtroom%20with%20dramatic%20shadows%2C%20deep%20blue%20tones%20with%20orange%20accent%20light%2C%20tense%20atmosphere%2C%20cinematic%20portrait&width=600&height=840&seq=movie-m004-01&orientation=portrait",
    summary: "一桩看似普通的交通肇事案，牵出一场关于正义与沉默的法庭博弈。",
    review: "剧本结构严谨，法庭戏的节奏设计极具张力，每一次证词反转都牢牢抓住观众情绪。演员在细微表情上的拿捏十分精准，是近期韩国类型片中的高分之作。",
    director: "金在赫",
    actorIds: ["a006", "a001"],
    duration: "132分钟",
    clicks: 134500,
  },
  {
    id: "t001",
    title: "长夜回廊",
    year: 2024,
    type: "tv",
    genre: ["悬疑", "古装"],
    region: "中国大陆",
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20mystery%20drama%20poster%2C%20a%20figure%20in%20traditional%20robes%20walking%20through%20a%20dark%20long%20corridor%20with%20lanterns%2C%20deep%20blue%20night%20tones%2C%20warm%20orange%20lantern%20glow%2C%20cinematic%20period%20drama&width=600&height=840&seq=tv-t001-01&orientation=portrait",
    summary: "一场宫廷命案牵出尘封十年的旧案，查案者在重重迷雾中寻找真相。",
    review: "服化道考究，叙事结构采用双线并行，悬念铺陈层层递进。主演的演技细腻到位，将角色内心的挣扎与坚定刻画得入木三分，是今年古装悬疑剧的标杆之作。",
    director: "沈知行",
    actorIds: ["a003", "a005"],
    duration: "共36集",
    clicks: 221300,
  },
  {
    id: "t002",
    title: "都市浮光",
    year: 2023,
    type: "tv",
    genre: ["都市", "爱情"],
    region: "中国大陆",
    rating: 8.1,
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20poster%2C%20a%20couple%20standing%20on%20a%20city%20rooftop%20at%20dusk%20with%20skyline%20lights%2C%20navy%20blue%20sky%20with%20warm%20orange%20sunset%20glow%2C%20cinematic%20portrait%20composition&width=600&height=840&seq=tv-t002-01&orientation=portrait",
    summary: "两位在职场中各自打拼的年轻人，在一次次碰撞与误解中走向彼此理解。",
    review: "职场线与情感线融合自然，没有落入悬浮剧的窠臼，对都市年轻人的生活压力与情感诉求刻画真实可信，男女主角之间的化学反应是全剧最大亮点。",
    director: "陈牧之",
    actorIds: ["a004", "a002"],
    duration: "共32集",
    clicks: 189700,
  },
  {
    id: "t003",
    title: "破晓行动",
    year: 2022,
    type: "tv",
    genre: ["谍战", "动作"],
    region: "中国大陆",
    rating: 9.0,
    cover: "https://readdy.ai/api/search-image?query=Espionage%20action%20drama%20poster%2C%20a%20determined%20agent%20in%20a%20trench%20coat%20walking%20through%20a%20foggy%20old%20city%20street%20at%20night%2C%20deep%20blue%20cold%20tones%2C%20subtle%20orange%20streetlight%2C%20tense%20cinematic%20mood&width=600&height=840&seq=tv-t003-01&orientation=portrait",
    summary: "抗战时期，一批潜伏特工在敌后战线上展开惊心动魄的情报较量。",
    review: "节奏紧凑，悬念设置精巧，几场谍战交锋戏调度出色，演员群像塑造立体，是近几年谍战题材剧集中口碑与收视双丰收的代表作。",
    director: "赵凌峰",
    actorIds: ["a001", "a006"],
    duration: "共40集",
    clicks: 267800,
  },
  {
    id: "t004",
    title: "青梅集市",
    year: 2024,
    type: "tv",
    genre: ["喜剧", "治愈"],
    region: "日本",
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20Japanese%20slice-of-life%20comedy%20drama%20poster%2C%20a%20small%20town%20market%20street%20with%20warm%20lantern%20lights%20at%20twilight%2C%20soft%20orange%20and%20muted%20blue%20palette%2C%20gentle%20heartwarming%20atmosphere&width=600&height=840&seq=tv-t004-01&orientation=portrait",
    summary: "一条老旧商店街上，几位性格迥异的店主与顾客之间发生的温馨治愈故事。",
    review: "轻松幽默又不失生活质感，每一集都有独立的小故事却又彼此呼应，看完让人心情平静愉悦，是下班后放松解压的理想选择。",
    director: "小林悠",
    actorIds: ["a005", "a004"],
    duration: "共24集",
    clicks: 98650,
  },
];

export const getMovieById = (id: string) => movies.find((m) => m.id === id);